import React from 'react';
import { Container, Box, Flex, css, Link, Image } from 'theme-ui';
import Reveal from '@solid-ui-components/Reveal';
import Divider from '@solid-ui-components/Divider';
import ContentText from '@solid-ui-components/ContentText';
import Icon from '@solid-ui-components/ContentIcon';
import WithDefaultContent from '@solid-ui-blocks/WithDefaultContent';
import photo from '../../../../../targpatrol-en/content/assets/flexiblocks/industrial/manufacturing-workflow.svg'
import LayoutWrapper from '@solid-ui-layout/LayoutWrapper/LayoutWrapper';

const styles = {
  container: {
    my: '60px',
    display: 'flex',
    flexDirection: ['column', 'column', 'column', 'column', 'row'],
    position: 'relative',
    background: 'linear-gradient(94.64deg, #1A98D8 0%, #026AA2 100%)',
    borderRadius: '24px',
    height: 'auto'
  },
  textBlock: {
    width: ['100%', '100%', '100%', '100%', '53%'],
    textAlign: 'left',
    mt: ['30px', null, null, null, null],
    p: [null, null, null, null, '32px'],
    px: ['15px', null, null, null, '64px'],
    alignContent: 'center'
  },
  buttonContainer: {
    border: '1px solid #FFFFFF',
    backgroundColor: '#fff',
    py: '12px',
    px: '20px',
    display: 'flex',
    gap: '8px',
    width: 'fit-content',
    borderRadius: '8px',
    textDecoration: 'none',
    transition: 'all ease 250ms',
    '&:hover': {
      backgroundColor: 'transparent',
      borderColor: 'white',
      '& p': {
        color: '#fff',
      },
      '& path': {
        stroke: '#fff',
      },
    },
  },
  button: {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '30px',
    color: '#026AA2',
    margin: 0,
    transition: 'all ease 250ms',
  },
  imageBlock: {
    width: ['100%', '100%', '100%', '100%', '50%'],
    mt: ['30px', null, null, null],
    ml: ['20px', null, null, null],
    display: 'flex',
    justifyContent: 'bottom',
    alignItems: 'bottom',
  },
};

const GetStartedWithPhoto = ({ content: { text, collection, buttons } }) => (
  <LayoutWrapper>
    <Container sx={styles.container}>
      <Box sx={styles.textBlock}>
        <Reveal effect='fadeInDown'>
          <ContentText
            content={[
              {
                ...text[0],
                as: 'h2',
                variant: 'h2compact',
              },
              ...text.slice(1),
            ]}
          />
        </Reveal>
        <Reveal effect='fadeInUp'>
          <Divider space={3} />
          <Link
            href={buttons[0].link}
            sx={styles.buttonContainer}
            target='_blank'
            rel='noreferrer'
          >
            <p css={css(styles.button)}>{buttons[0].text}</p>
            <Icon content={collection[0].icon} size='xxs' mt={'5px'} />
          </Link>
        </Reveal>
      </Box>
        <Box sx={styles.imageBlock}>
          <Image src={photo} alt="management-workflow" />
        </Box>
    </Container>
  </LayoutWrapper>
);

export default WithDefaultContent(GetStartedWithPhoto);
